(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tl-featured-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tl-variant-modal-controller')) {
    customElements.define('tl-variant-modal-controller', class extends HTMLElement {});

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-tl-variant-open]');
      if (opener) {
        const modal = document.getElementById(opener.dataset.tlVariantOpen);
        if (modal && typeof modal.showModal === 'function') {
          modal.showModal();
        }
        return;
      }

      const closeButton = event.target.closest('[data-tl-variant-close]');
      if (closeButton) {
        closeButton.closest('dialog')?.close();
      }
    });

    document.addEventListener('click', (event) => {
      const modal = event.target.closest('.tl-variant-modal');
      if (modal && event.target === modal) {
        modal.close();
      }
    });

    document.addEventListener('submit', (event) => {
      const productForm = event.target.closest('.tl-variant-modal product-form');
      if (!productForm) return;

      const modal = productForm.closest('dialog');
      const submitButton = productForm.querySelector('[type="submit"]');
      if (!modal || !submitButton) return;

      const observer = new MutationObserver(() => {
        const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
        if (!submitButton.classList.contains('loading')) {
          observer.disconnect();
          if (!errorWrapper || errorWrapper.hasAttribute('hidden')) {
            modal.close();
          }
        }
      });

      observer.observe(submitButton, { attributes: true, attributeFilter: ['class'] });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
